import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {AccessibilityService} from './../../services/accessibility.service';
import { BaseComponent } from './../base/base.component';


@Component({
    selector: 'app-alert',
    styleUrls: ['./alert.component.scss'],
    templateUrl: './alert.component.html'
})
export class AlertComponent extends BaseComponent {

    @ViewChild('popup') public popup: any;
    @Input() title: string;
    @Input() description: string;
    @Output() yesClickedEvent: EventEmitter<string> = new EventEmitter();
    @Output() noClickedEvent: EventEmitter<string> = new EventEmitter();
    @Output() okClickedEvent: EventEmitter<string> = new EventEmitter();
    @Input() type: POPUPTYPE;

    focusEle: any;

    classList = '';

    constructor(accService: AccessibilityService, ele: ElementRef) {
        super(ele);

        this.type = POPUPTYPE.RESPONSE;
    }

    /**
     * show alert popup
     */
    showAlert() {
        this.classList = '';
        this.popup.show();
    }

    /**
     * hide alert popup
     */
    hideAlert() {
        this.classList = '';
        this.popup.hide();
        if (this.focusEle) {
            this.focusEle.focus();
        }

        if (this.type === POPUPTYPE.RESPONSE) {
            this.noClickedEvent.next();
        } else {
            this.okClickedEvent.emit();
        }

    }
    confirmCB() {
        this.popup.hide();
        this.yesClickedEvent.next();


    }
    setFocus() {
        const focusEle = document.getElementById('alert-close');
        if (focusEle) {
            setTimeout( () => {
            focusEle.focus();
            }, 100);
        }
    }

    handleKeyOnCloseButton( event: any ) {

      let eleFocusableElement: HTMLElement = null;

          if ( this.type  === 1 )  {
                eleFocusableElement = <HTMLElement> document.getElementById('ok-alert');
            } else if (  event.keyCode === 9 ) {
                if ( event.shiftKey ) {
                    eleFocusableElement = <HTMLElement> document.getElementById('no-alert');
                } else {
                     eleFocusableElement = <HTMLElement> document.getElementById('yes-alert');
            }
        }
  if ( eleFocusableElement !== null ) {
          setTimeout( () => {
                  eleFocusableElement.focus();
         }, 100)}
    }
        }

export enum POPUPTYPE {
    RESPONSE = 0,
    INFORMATIVE = 1
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/alert/alert.component.ts